import React, { useState, useEffect } from "react";
import {
    Grid,
    List,
    Button,
    TextareaAutosize,
    Typography,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";

/** Local deoendencies & Libraries */
import Services from "../../../Services";
import Snackbar from "../../../Components/Snackbar";
import { helpers } from "../../../helpers";
import { ListItemResult } from "../../../Imports/TableImports";
import { showText, showTextEmpty, ValidateDate, ValidateDateAndTime } from "../../../helpers/textValidation";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";

const { hr } = Services;

const { showSnackBar } = helpers;

var moment = require("moment-timezone");

const TicketUpdate = () => {
    let history = useHistory();
    const location = useLocation();
    const [date, setDate] = useState(new Date());
    const [tickets, setTickets] = useState({});

    const [ticketID, setticketID] = useState("");
    const [Comment, setComment] = useState("");

    useEffect(async () => {
        window.scrollTo(0, 0);
        let ticketData = location?.state;

        setticketID(ticketData);
        try {
            let data = await hr.get_tickets_by_id(ticketData);

            setTickets(data);
            setComment(data?.data?.close_comment ? data?.data?.close_comment : null);
        } catch (exc) {

        }
    }, []);

    function handleComment(value) {
        setComment(value);
    }

    async function onSubmitTicket(event) {
        event.preventDefault();

        let data = {
            comment: Comment,
            id: ticketID.id,
        };


        try {
            let data1 = await hr.update_tickets(data);
            setTimeout(() => {
                history.push("/tickets-alerts");
            }, 1500);
            return showSnackBar("Form Successfully Submitted");
        } catch (exc) {

            return showSnackBar(`Error Occured while submitting form: ${exc}`);
        }
    }

    const ticketInfo = [
        {
            head: "Ticket ID",
            text: showText(tickets?.data?.id),
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Ticket Requested For",
            text: `${showTextEmpty(tickets?.data?.FEmployee?.firstName)} ${showTextEmpty(tickets?.data?.FEmployee?.lastName)}`,
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Ticket Requested By",
            text: `${showTextEmpty(tickets?.data?.BEmployee?.firstName)} ${showTextEmpty(tickets?.data?.BEmployee?.lastName)}`,
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Date Ticket Entered",
            text: ValidateDate(tickets?.data?.createdAt),
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Ticket Department",
            // text: "Director of Systems",
            text: showText(tickets?.data?.TicketType?.name),
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Sender Email",
            text: showText(tickets?.data?.senderEmail),
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Ticket Category",
            text: showText(tickets?.data?.TicketCategory?.name),
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Ticket Comments",
            text: showText(tickets?.data?.creation_comment),
            span: false,
            visibility: true,
            showButton: false,
        },
        {
            head: "Ticket Completed By",
            text: showTextEmpty(tickets?.data?.CEmployee?.firstName) +
                " " +
                showTextEmpty(tickets?.data?.CEmployee?.lastName),
            span: false,
            visibility: tickets?.data?.isCompleted,
            showButton: false,
        },

        {
            head: "Closeout Comments",
            text: showText(tickets?.data?.close_comment),
            onClick: false,
            span: false,
            visibility: tickets?.data?.isCompleted,
            showButton: false,
        },
        {
            head: "Closeout Date",
            text: ValidateDate(tickets?.data?.closeDate).toString(),
            span: false,
            visibility: tickets?.data?.isCompleted,
            showButton: false,
        },
        {
            head: "Closeout Reason",
            text: ValidateDate(tickets?.data?.closeDate).toString(),
            span: false,
            visibility: tickets?.data?.isCompleted,
            showButton: false,
        },
    ];
    return (
        <PageLayout className="Liq-Container HRPortal AlertUpdate">
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Tickets/Alerts</Grid>
                {/* Page Start */}
                <Grid xs={12} md={6} className="TicketAlertTab">

                </Grid>
                <Grid xs={12} className="TicketAlertTabH1">
                    <Typography variant="h1" component="h2">
                        Update Ticket
                    </Typography>
                </Grid>
                <Grid xs={12} className="ContentPage FormTableArea">
                    <Grid xs={12} container>
                        <Grid xs={8}>
                            <List>
                                <ListItemResult data={ticketInfo} />
                            </List>
                        </Grid>
                        <form className="w-100" onSubmit={onSubmitTicket}>
                            <Grid xs={12} md={6}>
                                {/* ---------- */}
                                {!tickets?.data?.isCompleted ? (
                                    <Grid xs={12} container>
                                        <Grid xs={12} className="mt30 pr40">
                                            <Grid xs={12}>
                                                <Grid xs={12} className="mbold">
                                                    Closeout Comment
                                                </Grid>

                                                <Grid xs={12} className="mt14">
                                                    <TextareaAutosize
                                                        style={{ width: "600px" }}
                                                        id="comment"
                                                        className="w100p"
                                                        rowsMin={6}
                                                        maxLength={250}
                                                        placeholder="Comment here"
                                                        required={true}
                                                        onChange={(event, value) => {
                                                            handleComment(event.target.value);
                                                        }}
                                                        disabled={
                                                            tickets?.data?.close_comment ? true : false
                                                        }
                                                        value={Comment}
                                                    />
                                                </Grid>
                                                <Typography
                                                    variant="h6"
                                                    className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary"
                                                    component="h6"
                                                >
                                                    Please leave this field empty if you have no
                                                    comments
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ) : null}
                                <Grid
                                    xs={24}
                                    container
                                    justify="space-between"
                                    className="mt50 pr40"
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "200%" }}
                                >
                                    <Link to="/tickets-alerts" className="LinkButtonBack">
                                        back
                                    </Link>
                                    <div style={{ display: "flex", gap: "20px" }}>
                                        <Button
                                            type="submit"
                                            disabled={tickets?.data?.close_comment ? true : false}
                                            className="LinkButtonBack"
                                        >
                                            Save
                                        </Button>
                                        {!tickets?.data?.isCompleted ? (
                                            <Button
                                                type="submit"
                                                disabled={tickets?.data?.close_comment ? true : false}
                                                className="LinkButton"
                                            >
                                                Close Comment
                                            </Button>
                                        ) : null}

                                    </div>

                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                    <Snackbar></Snackbar>
                </Grid>
                {/* Page Start End */}
            </Grid>
        </PageLayout>
    );
};

export default TicketUpdate;
